import React, { useEffect, useState } from "react";
import { PRIMARY_COLOR } from "../../assets/style/colors";
import {
  CartBar,
  CartGreen,
  client_inactive,
  home_active,
  HomeBar,
  homeGreen,
  PricelistBar,
  pricelistGreen,
  Profilebar,
  profileGreen,
  RechargeBar,
  rechargeGreen,
} from "../../assets/img";
import { useLocation, useNavigate } from "react-router-dom";
import { ICON_FILTER } from "../../Services/Constant";
import { MaskIcon } from "../../Screen/MaskIcon";

const Footer = () => {
  const navigate = useNavigate();

  // State to track active tab
  const [activeTab, setActiveTab] = useState("home");
  const [keyboardOpen, setKeyboardOpen] = useState(false);

  useEffect(() => {
    if (window.visualViewport) {
      const onResize = () => {
        // If viewport height is reduced → Keyboard is open
        const isKeyboard =
          window.visualViewport.height < window.innerHeight - 150;
        setKeyboardOpen(isKeyboard);
      };

      window.visualViewport.addEventListener("resize", onResize);
      return () =>
        window.visualViewport.removeEventListener("resize", onResize);
    }
  }, []);

  const tabs = [
    {
      name: "home",
      label: "Home",
      icon: HomeBar,
      icon2: homeGreen,
      path: "/home",
    },
    {
      name: "recharge",
      label: "Recharge",
      icon: RechargeBar,
      icon2: rechargeGreen,
      path: "/recharge",
    },
    {
      name: "pricelist",
      label: "Price List",
      icon: PricelistBar,
      icon2: pricelistGreen,
      path: "/price-list",
    },
    {
      name: "cart",
      label: "Cart",
      icon: CartBar,
      icon2: CartGreen,
      path: "/cart",
    },
    {
      name: "profile",
      label: "Profile",
      icon: Profilebar,
      icon2: profileGreen,
      path: "/profile",
    },
  ];

  const handleTabClick = (tab) => {
    setActiveTab(tab.name);
    navigate(tab.path, {
      state: { fromFooter: true },
      replace: tab.name === "cart",
    });
  };

  return (
    
    <div
      style={{
        display: keyboardOpen ? "none" : "flex",
        height: keyboardOpen ? 0 : 65,
        position: "fixed",
        margin: "0 auto",
      }}
      className="footer-container"
    >
      <svg width="0" height="0" style={{ position: "absolute" }}>
        <defs>
          <filter id="brand-color" x="0" y="0" width="100%" height="100%">
            <feFlood floodColor={PRIMARY_COLOR} floodOpacity="1" result="color" />
            <feComposite in="color" in2="SourceGraphic" operator="in" />
          </filter>
        </defs>
      </svg>
      {tabs.map((tab) => (
        <div
          key={tab.name}
          onClick={() => handleTabClick(tab)}
          className={`footer-item ${activeTab === tab.name ? "active" : ""}`}
        >
           {activeTab === tab.name  ? (
          <img
            src={tab.icon2}
            width={22}
            height={22}
            alt={tab.label}
            style={{
              filter: "url(#brand-color)",
            }}
          />
        ) : (
          <img
            src={tab.icon}
            width={22}
            height={22}
            alt={tab.label}
            style={{ opacity: 1 }}
          />
        )}
          <p
            className="footer-label f3"
            style={{
              color: activeTab === tab.name ? PRIMARY_COLOR : "#555",
              fontWeight: activeTab === tab.name ? 600 : 400,
            }}
          >
            {tab.label}
          </p>
        </div>
      ))}
    </div>
  );
};

export default Footer;
